import { AfterContentInit, Component, ElementRef, Inject, ViewChild } from "@angular/core";
import { ILocationService } from "angular";
import { Notification, SystemNotification } from "ng/src/app/notifications/notification.model";
import { NotificationService } from "../notification.service";
import { fromMediaQuery, MediaQueries } from "ng/src/app/shared/media-query-observable";
import { SystemNotificationService } from "ng/src/app/notifications/system-notification.service";

type NotificationWithLog = Notification.Projections.WithLogName;

@Component({
	templateUrl: './notification-page.component.html',
	styleUrls: ['./notification-page.component.css']
})
export class NotificationPageComponent implements AfterContentInit {
	@ViewChild('notificationView') notificationView?: ElementRef;
	
	mobileMediaQuery = fromMediaQuery(MediaQueries.NARROW_SCREEN);
	
	get tab() {
		return this._tab;
	}
	
	set tab(val) {
		this._tab = val;
	}
	
	get selectedNotification() {
		return this._selectedNotification;
	}
	
	set selectedNotification(val) {
		this._selectedNotification = val;
		this.updateLocation();
	}
	
	private _tab: 'user' | 'system' = 'user';
	private _selectedNotification?: NotificationWithLog | SystemNotification;
	
	
	constructor(
		private notificationService: NotificationService,
		private systemNotificationService: SystemNotificationService,
		@Inject("$location") private $location: ILocationService
	) { }
	
	ngAfterContentInit(): void {
		const search = this.$location.search();
		
		if (search['tab'] === 'system') {
			this._tab = 'system';
		}
		
		if (search['notification']) {
			if (this.tab === 'system') {
				this.systemNotificationService.getById(search['notification']).subscribe(n => {
					if (n) {
						this.selectedNotification = n;
					}
					this.updateLocation();
				})
			}
			else {
				this.notificationService.findById(search['notification']).subscribe(n => {
					if (n) {
						this.selectedNotification = n;
					}
					this.updateLocation();
				})
			}
		}
	}
	
	isSystemNotification(n: NotificationWithLog | SystemNotification): SystemNotification | undefined {
		return 'title' in n ? n : undefined;
	}
	
	isUserNotification(n: NotificationWithLog | SystemNotification): NotificationWithLog | undefined {
		return 'logId' in n ? n : undefined;
	}
	
	private updateLocation() {
		this.$location
			.search('tab', this.tab === 'system' ? 'system' : null)
			.search('notification', this.selectedNotification?.id ?? null)
			.replace();
	}
}